import { buildCanonicalEvent, type Severity } from './canonicalEvent';
import { getAppInsights, getTraceContext } from './appInsights';
import { runtimeEnv } from '../../runtimeEnv';
import { createLogger } from '../logging';

const ctx = { serviceVersion: runtimeEnv.buildSha, environment: runtimeEnv.environment };

// Console mirror of canonical events. Toggle with localStorage.debug = 'eh:telemetry'
// (or 'eh:*'); off by default. App Insights is the real telemetry sink below.
const log = createLogger('telemetry');

// Emit one canonical event. `body` is required (rule 3). trace_id/span_id come
// from the App Insights operation context. Domain `fields` must never contain PII.
export function logEvent(
  name: string, body: string, fields: Record<string, unknown> = {}, severity: Severity = 'INFO',
): void {
  const event = buildCanonicalEvent(name, body, { ...getTraceContext(), ...fields }, ctx, severity);
  const ai = getAppInsights();
  if (severity === 'ERROR' || severity === 'FATAL') {
    ai?.trackException({ exception: new Error(name), properties: event });
  } else {
    ai?.trackEvent({ name }, event);
  }
  log('%s %o', name, event);
}
